import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ClienteService } from 'src/app/service/cliente.service';

@Component({
  selector: 'app-activar',
  templateUrl: './activar.component.html',
  styleUrls: ['./activar.component.css']
})
export class ActivarComponent implements OnInit {
  public key:string='';
  public activado:boolean=false;
  constructor(private rutaActiva: ActivatedRoute, private cliente: ClienteService) {
    this.key =this.rutaActiva.snapshot.params.key;
    cliente.activar(this.key).then((value:any)=>{
        this.activado=true;
    });
   }

  ngOnInit(): void {

  }
  redir(){
    window.location.href = "/login";
  }
}
